export default __webpack_public_path__ + "static/media/cover-placeholder.831fae42.svg";